import { useMutation } from '@tanstack/react-query';

import { AddStrategyRequest } from './types';
import { addStrategy } from '../../../../../../api';

export const useAddStrategy = () =>
  useMutation({ mutationKey: ['addStrategy'], mutationFn: (data: AddStrategyRequest) => addStrategy(data) });
